import useAuthUtilities from '@/AuthMiddleware/AuthUtilities';
import { projectServiceApiClient } from '@/clients/ProjectServiceApiClient';
import { useMutation } from '@tanstack/react-query';

export default function useRemoveFromProjectMutation() {
  const { canUserReadProjectService, canUserWriteProjectService } =
    useAuthUtilities();

  return useMutation({
    mutationFn: async ({
      projectId,
      contentUrn,
    }: {
      projectId: number;
      contentUrn: string;
    }) => {
      if (!canUserReadProjectService() || !canUserWriteProjectService()) {
        return;
      }

      await projectServiceApiClient.removeFromProject(projectId, contentUrn);
    },
  });
}
